<template>
  <FormLabel :text="text" :error="error">
    <input class="aoformfield" :placeholder="placeholder" autocomplete="off"
           ref="input"
           :type="type"
           inputmode="numeric"
           :disabled="$store.state.loading"
           :name="name"
           v-maska="mask"
           v-model="val"
           @focus="fillStartMask"
           @blur="filledCheck">
  </FormLabel> 
</template>

<script>
import FormLabel from '@/components/FormLabel.vue'
import FormField from '@/mixins/FormField.vue'
import { maska } from 'maska'

export default {
  components: { FormLabel },
  mixins: [FormField],
  directives: { maska },
  props: {
    name: {type: String, required: true},
    value: {type: String, default: ''},
    text: {type: String, required: true},
    type: {type: String, default: 'text'},
    placeholder: {type: String},
    mask: {type: String},
    validation: {type: Function, default: ()=>''},
    filled: {type: Function, default: (v)=>v?true:false}
  },
  data: ()=>({
    error: '',
    collector: {}
  }),
  mounted(){
    if (this.$parent.fieldsStatus)
      this.collector = this.$parent.fieldsStatus
    else if (this.$parent.$parent.fieldsStatus)
      this.collector = this.$parent.$parent.fieldsStatus

    if (this.collector)
      this.collector[this.name] = false
  },
  computed:{
    val: {
      get () { return this.value },
      set (value) { this.$emit('input', value) },
    },
  },
  methods:{
    fillStartMask(){
      if (this.mask && this.val.length < this.mask.match(/^[^#]*(?=#)/)[0].length) {
        this.val = this.mask.match(/^[^#]*(?=#)/)[0]
      }
    },
    filledCheck(){
      if (!this.filled(this.value)) {
        this.error = "Заполните поле"
        this.collector[this.name] = false
      }
    }
  },
  watch: {
    value(newVal){
      this.error = this.validation(newVal)
      if (this.error || !this.filled(newVal))
        this.collector[this.name] = false
      else
        this.collector[this.name] = true      
    }
  }
}
</script>

<style lang="sass">

</style>